import type { ExternalTableSchema } from '@packages/table-builder';

/** Resolve transfer-allocate list/detail URLs — server + legacy schemas use `{id}` or `{transferAllocateId}`. */
export function resolveTransferAllocateIdInEndpoint(
  template: string,
  transferAllocateId: string,
): string {
  return template
    .replaceAll('{transferAllocateId}', transferAllocateId)
    .replaceAll('{id}', transferAllocateId);
}

export function withTransferAllocateIdEndpoint(
  schema: ExternalTableSchema,
  transferAllocateId: string,
): ExternalTableSchema {
  const endpoint = schema.dataSource?.endpoint;
  if (!endpoint) return schema;

  return {
    ...schema,
    dataSource: {
      ...schema.dataSource,
      endpoint: resolveTransferAllocateIdInEndpoint(endpoint, transferAllocateId),
    },
  };
}
